const BffGenericErrorCode = require('../../bff-generic-error-codes');

const ErrorCodes = {
  EPZ_OAUTH_ACCESS_DENIED: 'EPZ_OAUTH_ACCESS_DENIED',
  EPZ_ACCESS_FORBIDDEN: 'EPZ_ACCESS_FORBIDDEN',
};

const PzOauthErrorCodes = { ...ErrorCodes, ...BffGenericErrorCode };

module.exports = PzOauthErrorCodes;
